
/**
 * Module dependencies.
 */

import {
  authorizationHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  productId: string,
  token: string
};

/**
 * Export `createFavorite`.
 */

export async function createFavorite({ productId, token }: Query) {
  const endpoint = getApiEndpoint('getUserFavorites');

  try {
    const { data } = await request.post(endpoint, { productId }, {
      headers: authorizationHeader(token)
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
